module.exports = __webpack_public_path__ + "img/visuel4-hk.08374ff9.jpg";